const PLC_URLS = {
  press1: 'https://cx-505ad0.live.parallelfluidics.com/tcadswebservice/tcadswebservice.dll',
  press2: 'https://cx-505ad0.live.parallelfluidics.com/tcadswebservice/tcadswebservice.dll',
  press3: 'https://cx-729f70.live.parallelfluidics.com/tcadswebservice/tcadswebservice.dll',
  press4: 'https://cx-729f70.live.parallelfluidics.com/tcadswebservice/tcadswebservice.dll',
  press5: 'https://btn-000tkm3d.live.parallelfluidics.com/tcadswebservice/tcadswebservice.dll',
  test1: 'https://btn-000tkm3p.live.parallelfluidics.com/tcadswebservice/tcadswebservice.dll',
};

const PRESS_TITLES = {
  press5: 'Press 5',
  test1: 'Test 1',
};

const normalizePressId = (pressId) => (pressId || '').trim().toLowerCase();

const getPLCUrl = (pressId) => PLC_URLS[normalizePressId(pressId)];

const getPressTitle = (pressId) => PRESS_TITLES[normalizePressId(pressId)];

export {
  getPLCUrl,
  getPressTitle,
  normalizePressId,
};
